import { Container, Group, Stack, Text, Anchor } from "@mantine/core";
import { Link } from "react-router-dom";
import { artist } from "@/content/artist";

export function Footer() {
  return (
    <Container
      size="xl"
      px={{ base: "md", md: "xl" }}
      py="xl"
      style={{ borderTop: "1px solid var(--color-ocean)" }}
    >
      <Stack gap="md">
        <Group justify="space-between" wrap="wrap">
          <Text size="sm" c="var(--color-foam)">
            © {new Date().getFullYear()} 7 Minutes Dead
          </Text>
          <Group gap="lg">
            {artist.socials.map((s) => (
              <Anchor
                key={s.platform + s.url}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                size="sm"
                c="var(--color-foam)"
              >
                {s.label ?? s.platform}
              </Anchor>
            ))}
          </Group>
        </Group>
        <Text size="xs" c="dimmed">
          Press / label access:{" "}
          <Anchor component={Link} to="/access" size="xs" c="var(--color-foam)">
            enter token
          </Anchor>
        </Text>
      </Stack>
    </Container>
  );
}
